import { APISearchDVF } from 'interfaces/API'
import { Dvf, Mutation, Parcelle } from 'interfaces/Dvf'
import { useAppDispatch, useAppSelector } from 'redux/hooks'
import { fetchWithCheckAuthorization } from 'utils/fetchWithAuthorization'
import {
  succeededDvf,
  loadingDvf,
  errorDvf as errorDvfAction,
  Status,
  showModalBeaucoupDeResultats,
  showParcelleResults,
} from 'redux/features/dvf/slice'
import {
  makeSelectParcelles,
  makeSelectMutations,
  makeSelectStatusDvf,
  makeSelectErrorDvf,
} from 'redux/features/dvf/selectors'

interface ReturnProps {
  parcelles: Parcelle[]
  mutations: { [uid: string]: Mutation }
  statusDvf: Status
  errorDvf: string | null
  fetchSearchDVF: (d: APISearchDVF) => Promise<Dvf | null>
}

const useDvf = (): ReturnProps => {
  const parcelles = useAppSelector(makeSelectParcelles)
  const mutations = useAppSelector(makeSelectMutations)
  const statusDvf = useAppSelector(makeSelectStatusDvf)
  const errorDvf = useAppSelector(makeSelectErrorDvf)
  const dispatch = useAppDispatch()

  const fetchSearchDVF = async (
    dataForm: APISearchDVF
  ): Promise<Dvf | null> => {
    try {
      dispatch(loadingDvf())
      const response = await fetchWithCheckAuthorization(`/api/search/dvf`, {
        method: 'POST',
        body: JSON.stringify(dataForm),
      })
      const { results, message }: { results: Dvf; message: string } =
        await response.json()

      if (!response.ok) {
        console.error(message)
        if (message[0].includes('cityCode'))
          throw Error(
            'Veuillez choisir au moins une localisation pour lancer votre recherche'
          )
        if (message[0].includes('surfaceAuSol.max')) throw Error(message[0])
        throw Error('Une erreur est survenue')
      }
      dispatch(succeededDvf(results))
      if (Object.keys(results.mutations).length >= 700)
        dispatch(showModalBeaucoupDeResultats())
      else dispatch(showParcelleResults())

      return results
    } catch (err: unknown) {
      console.error(err)
      dispatch(errorDvfAction((err as Error).toString()))
      return null
    }
  }

  return {
    parcelles,
    mutations,
    statusDvf,
    errorDvf,
    fetchSearchDVF,
  }
}

export default useDvf
